import {
  CreateSourceWebhookAction,
  CreateSourceWebhookActionType,
  SetBatchIntervalSecondsAction,
  SetBatchMaxSizeAction,
  SetCredentialsAction,
  SetErrorAction,
  SetPhaseAction,
  SetShouldShowErrorsAction,
  SetSignatureHeaderAction,
  SetSourceIdAction,
  SetSourceNameAction,
} from "@/pages/sources/components/create/sources/webhook/actions";
import {
  CreateSourceWebhookPhase,
  CreateSourceWebhookState,
} from "@/pages/sources/components/create/sources/webhook/types";

function setSourceName(
  state: CreateSourceWebhookState,
  action: SetSourceNameAction,
): CreateSourceWebhookState {
  return {
    ...state,
    sourceName: action.payload,
  };
}

function setPhase(
  state: CreateSourceWebhookState,
  action: SetPhaseAction,
): CreateSourceWebhookState {
  return {
    ...state,
    phase: action.payload,
    error: action.payload === CreateSourceWebhookPhase.ERROR ? state.error : null,
  };
}

function setSignatureHeader(
  state: CreateSourceWebhookState,
  action: SetSignatureHeaderAction,
): CreateSourceWebhookState {
  return {
    ...state,
    signatureHeader: action.payload,
  };
}

function setBatchIntervalSeconds(
  state: CreateSourceWebhookState,
  action: SetBatchIntervalSecondsAction,
): CreateSourceWebhookState {
  return {
    ...state,
    batchIntervalSeconds: action.payload,
  };
}

function setBatchMaxSize(
  state: CreateSourceWebhookState,
  action: SetBatchMaxSizeAction,
): CreateSourceWebhookState {
  return {
    ...state,
    batchMaxSize: action.payload,
  };
}

function setCredentials(
  state: CreateSourceWebhookState,
  action: SetCredentialsAction,
): CreateSourceWebhookState {
  return {
    ...state,
    credentials: action.payload,
  };
}

function setSourceId(
  state: CreateSourceWebhookState,
  action: SetSourceIdAction,
): CreateSourceWebhookState {
  return {
    ...state,
    sourceId: action.payload,
  };
}

function setError(
  state: CreateSourceWebhookState,
  action: SetErrorAction,
): CreateSourceWebhookState {
  return {
    ...state,
    error: action.payload,
    phase: action.payload ? CreateSourceWebhookPhase.ERROR : state.phase,
  };
}

function setShouldShowErrors(
  state: CreateSourceWebhookState,
  action: SetShouldShowErrorsAction,
): CreateSourceWebhookState {
  return {
    ...state,
    shouldShowErrors: action.payload,
  };
}

const createSourceWebhookReducer = (
  state: CreateSourceWebhookState,
  action: CreateSourceWebhookAction,
): CreateSourceWebhookState => {
  switch (action.type) {
    case CreateSourceWebhookActionType.SET_SOURCE_NAME:
      return setSourceName(state, action);
    case CreateSourceWebhookActionType.SET_PHASE:
      return setPhase(state, action);
    case CreateSourceWebhookActionType.SET_SIGNATURE_HEADER:
      return setSignatureHeader(state, action);
    case CreateSourceWebhookActionType.SET_BATCH_INTERVAL_SECONDS:
      return setBatchIntervalSeconds(state, action);
    case CreateSourceWebhookActionType.SET_BATCH_MAX_SIZE:
      return setBatchMaxSize(state, action);
    case CreateSourceWebhookActionType.SET_CREDENTIALS:
      return setCredentials(state, action);
    case CreateSourceWebhookActionType.SET_SOURCE_ID:
      return setSourceId(state, action);
    case CreateSourceWebhookActionType.SET_ERROR:
      return setError(state, action);
    case CreateSourceWebhookActionType.SET_SHOULD_SHOW_ERRORS:
      return setShouldShowErrors(state, action);
  }
};

export default createSourceWebhookReducer;
